
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/forms/become-a-partner",
      function () {
        return require("private-next-pages/egypt/forms/become-a-partner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/forms/become-a-partner"])
      });
    }
  